// Module `product-feedback`: the Feedback button in the app header. A person
// describes a bug, an idea or a question; the AI turns it into a short issue
// draft; Send stores it as a support ticket, emails support and, when
// configured, files a GitHub issue. (Not the events guest feedback at
// /feedback/:token.)
import { z } from "zod";
import { uuid } from "../schemas/common";
import { text } from "./common";

export const FEEDBACK_KINDS = ["bug", "idea", "question"] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

export const feedbackDraft = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  title: text(120, "Title"),
  problem: text(1000, "Problem"),
  details: z.array(text(500, "Detail")).max(8),
});
export type FeedbackDraft = z.infer<typeof feedbackDraft>;

export const feedbackMessage = z.object({ role: z.enum(["user", "assistant"]), text: text(4000, "Message") });
export type FeedbackMessage = z.infer<typeof feedbackMessage>;

/** POST /api/product-feedback/draft */
export const feedbackDraftBody = z.object({
  messages: z.array(feedbackMessage).min(1).max(20),
  fromPath: z.string().max(500).nullable(),
});
/** The AI's turn: a short question (reply) or a draft, never both empty. */
export type FeedbackDraftResult = { reply: string | null; draft: FeedbackDraft | null };

/** POST /api/product-feedback/issue */
export const feedbackIssueBody = z.object({
  draft: feedbackDraft,
  fromPath: z.string().max(500).nullable(),
  projectId: uuid.nullable(),
  transcript: z.array(feedbackMessage).max(40).optional(),
});
export type FeedbackIssueResult = { ticketId: string; issueNumber: number | null; issueUrl: string | null };
